import { sortBy } from 'lodash';
import i18next from 'i18next';
import moment from 'moment-timezone';

import { TIME_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import utilsXLS from '@commons/utils/makeXLS';

const getProductAllocationCommonsData = () => [
  {
    name: i18next.t('GENERAL.NAME'),
    propertyKey: 'name',
    width: 100,
  },
  {
    name: i18next.t('GENERAL.CATEGORY'),
    propertyKey: 'category',
    transform: (value) => value || i18next.t('GENERAL.NONE_VALUE'),
  },
];

const getProductAllocationSheetColumns = (timeSlots) => {
  const columns = getProductAllocationCommonsData();

  timeSlots.forEach(({ name, startTime, endTime, id }) => {
    const formattedStartTime = moment(
      startTime,
      TIME_DISPLAY_FORMATS.SLASHED_HOUR_MINUTE_SECOND,
    ).format(TIME_DISPLAY_FORMATS.SLASHED_HOUR_MINUTE);

    const formattedEndTime = moment(
      endTime,
      TIME_DISPLAY_FORMATS.SLASHED_HOUR_MINUTE_SECOND,
    ).format(TIME_DISPLAY_FORMATS.SLASHED_HOUR_MINUTE);

    columns.push({
      name: i18next.t('ADMIN.STORES.TIME_SLOTS_EXPORT_TIMESLOT_COLUMN_NAME', {
        name,
        startTime: formattedStartTime,
        endTime: formattedEndTime,
      }),
      propertyKey: `${id}`,
    });
  });

  columns.push({
    name: i18next.t('GENERAL.TOTAL'),
    propertyKey: 'total',
  });

  return columns;
};

export const exportStoreTimeSlots = (products, timeSlots, selectedStoreName) => {
  const sortedTimeSlots = sortBy(timeSlots, 'startTime');

  const productSheetColumns = getProductAllocationSheetColumns(sortedTimeSlots);

  const productAllocationSheet = utilsXLS.generateDefaultSheet(
    i18next.t('ADMIN.STORES.TIME_SLOTS_EXPORT_TIMESLOT_SHEET'),
    productSheetColumns,
    products,
    { numberDecimals: 2 },
    {
      cellsWidth: Array(productSheetColumns.length).fill({ wpx: 130 }),
    },
  );

  utilsXLS.makeXLS(
    i18next.t('ADMIN.STORES.TIME_SLOTS_EXPORT_FILENAME', {
      storeName: selectedStoreName,
    }),
    [productAllocationSheet],
  );
};
